export const FETCH_COUNTRIES = 'Countries/FETCH_COUNTRIES'
export const FETCH_COUNTRIES_SUCCESS = 'Countries/FETCH_COUNTRIES_SUCCESS'
export const FETCH_COUNTRIES_ERROR = 'Countries/FETCH_COUNTRIES_ERROR'
export const FETCH_COUNTRIES_DONE = 'Countries/FETCH_COUNTRIES_DONE'
